<template>
    <ul
        v-if="errors.length"
        class="unmapped-errors"
    >
        <li
            v-for="(error, key) in errors"
            :key="key"
            class="error"
        >
            {{ error.message }}
        </li>
    </ul>
</template>

<script setup lang="ts">
import type { BackendError } from '@/helpers/errors/collection'

defineProps<{
    errors: BackendError[]
}>()
</script>

<style lang="scss" scoped>
.unmapped-errors {
    width: 100%;
    padding: 1rem 1rem 1rem 2rem;
    border-radius: 2px;
    border: 1px solid $grey-300;
    border-left: 3px solid $red;
    background: $stone-3;
    color: $red;
    font-family: $effra-font-stack;
    text-transform: uppercase;
    font-size: 0.75rem;
    line-height: 1.5em;
    font-weight: 400;
    letter-spacing: 0.025em;

    .error {
        list-style-type: disc;
        margin: 0 0 10px 0;

        &:last-child {
            margin: 0;
        }
    }
}
</style>
